var map = {
	"./ActionsModal/Cambio.vue": 816,
	"./ActionsModal/SaveChanges.vue": 817,
	"./ActionsModal/index.vue": 277,
	"./agrocolor.vue": 2078,
	"./araporcei.vue": 2079,
	"./coplaca/ParcelasActionsMultiple.vue": 1174,
	"./coplaca/index.vue": 2080,
	"./default.vue": 2081,
	"./demo.vue": 2082,
	"./sites.vue": 325,
	"./widgets/auditorias.vue": 818,
	"./widgets/checklists.vue": 819,
	"./widgets/dictamenes.vue": 822,
	"./widgets/pacs.vue": 824,
	"./widgets/revisiones.vue": 821,
	"./widgets/solicitudes.vue": 820,
	"./widgets/toma_muestras.vue": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1785;